import React, { Component } from 'react'
import './topBar.css'

class TopBar extends Component {
  render() {
    return (
      <div className='top-bar'>
        <div className='app-name'>MyFamily</div>
      </div>

    )
  }
}

export default TopBar